import { FormControlLabel, Switch } from '@mui/material';
import { requiredLabel } from 'utils/form';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

export function SwitchField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isReadOnly,
  onChange,
}: FieldRendererProps) {
  return (
    <FormControlLabel
      className={className}
      sx={getFieldControlSx(hasWhiteFields, sx)}
      control={
        <Switch
          color="secondary"
          readOnly={isReadOnly}
          disabled={isDisabled}
          checked={field.value === 'on'}
          onChange={(event) => onChange(event.target.checked ? 'on' : '')}
          slotProps={{
            input: { 'aria-label': 'controlled' },
          }}
        />
      }
      label={requiredLabel(field.label, field.required)}
    />
  );
}
